import { GuestRelationModel } from 'api-hooks/guest';
import Separator from 'components/common/separator';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import Text from 'components/elements/text';
import { CardContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  data: GuestRelationModel[];
  isLoading: boolean;
}

export default function GuestRelationTable(props: Props) {
  const { t } = useTranslation();
  const { data, isLoading } = props;

  const columns = React.useMemo<IColumn<GuestRelationModel>[]>(
    () => [
      {
        header: t(`common:guest`),
        accessorKey: 'name',
        minSize: 100,
      },
      {
        header: t('common:relation'),
        accessorKey: 'type',
        minSize: 100,
      },
    ],
    [t],
  );

  return (
    <CardContainer>
      <Text variant="HeadingXSmall">{t('guest:guest_relation')}</Text>
      <Separator gap={16} />
      <TableComponent
        columns={columns}
        isLoading={isLoading}
        data={data || []}
      />
    </CardContainer>
  );
}
